/**
 * Catálogo de opciones de filtrado.
 *
 * Provisional: en cuanto el backend exponga facetas (`GET /restaurants/search/facets`), estas
 * listas deben venir de la respuesta, para no ofrecer filtros que no devuelven nada.
 * Vive en `core` y no en `data/api` para que la UI no dependa del simulador.
 */
export const FilterCatalog = {
  cuisines: [
    'Mexicana contemporánea',
    'Mexicana tradicional',
    'Italiana',
    'Japonesa',
    'Mariscos',
    'Vegetariana',
    'De autor',
    'Cafetería',
  ] as const,

  amenities: [
    'Terraza',
    'Estacionamiento',
    'Pet friendly',
    'Menú vegetariano',
    'Sin gluten',
    'Para llevar',
    'Wi-Fi',
    'Familiar',
  ] as const,

  locations: [
    { id: 'cdmx', label: 'Ciudad de México' },
    { id: 'polanco', label: 'Polanco' },
    { id: 'condesa', label: 'Condesa' },
    { id: 'roma', label: 'Roma Norte' },
    { id: 'centro', label: 'Centro Histórico' },
    { id: 'san-angel', label: 'San Ángel' },
  ] as const,
};
